import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import i18n from "../i18n";
import { LANGUAGES } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(i18n.resolvedLanguage || i18n.language || "en");

  const meta = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  useEffect(() => {
    const handler = (lng) => setLangState(lng);
    i18n.on("languageChanged", handler);
    return () => i18n.off("languageChanged", handler);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", meta.dir);
  }, [lang, meta.dir]);

  const setLang = useCallback((code) => {
    i18n.changeLanguage(code);
  }, []);

  // Full translation bundle for object-style access (t.nav.home)
  const t = i18n.getResourceBundle(lang, "translation") || i18n.getResourceBundle("en", "translation");

  // Localized CMS content resolver: field is { en, tr, ar } | string | array
  const tc = useCallback(
    (field) => {
      if (field == null) return "";
      if (typeof field === "string") return field;
      if (Array.isArray(field)) return field;
      const first = Object.values(field).find((v) => (Array.isArray(v) ? v.length : String(v || "").trim()));
      return field[lang] || field.en || first || "";
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tc, dir: meta.dir, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
